// import ReactGA from 'react-ga4';
import { takeEvery, all, take, select } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'redux-first-routing';
import {
  GA_COUPON_FAVORITE_ADDED,
  GA_COUPON_USED_BUYER,
  GA_COUPON_USED_SELLER,
  GA_FIELD_DRAWN,
  GA_LOGIN,
  GA_OFFERING_CREATED,
  GA_OFFERING_POSTING_BANK_DETAILS_REACHED,
  GA_OFFERING_POSTING_DATES_REACHED,
  GA_OFFERING_POSTING_EXTRA_FIELDS_REACHED,
  GA_OFFERING_POSTING_IMAGES_REACHED,
  GA_OFFERING_POSTING_LOCATION_REACHED,
  GA_OFFERING_POSTING_PRICING_REACHED,
  GA_OFFERING_POSTING_CATEGORY_REACHED,
  GA_OFFERING_POSTING_SUBMIT_REACHED,
  GA_OFFERING_POSTING_TITLE_DESCRIPTION_REACHED,
  GA_PAYMENT_ACCOUNT_ADDED,
  GA_QUESTION_ASKED,
  GA_QUOTE,
  GA_SIGNUP,
} from '../actionTypes';
import { HitchpinApi } from '../../api/Hitchpin';
import history from '../../history';

function* googleAnalyticsPageview() {
  const oldPath = yield select(
    store => store.router.pathname + store.router.search,
  );

  const { payload } = yield take(LOCATION_CHANGE);
  const { pathname, search } = payload;
  const newPath = [pathname, search].join('');

  if (newPath !== oldPath) {
    // ReactGA.pageview(newPath);
  }
}

// eslint-disable-next-line
const createGATrackingGenerator = (category, action) => () => {
  // ReactGA.event({
  //   category,
  //   action,
  // });
};

const sendAdwordsTrackingEvent = () => {
  if (
    process.env.REACT_APP_SENTRY_ENVIRONMENT === 'production' &&
    window.gtag
  ) {
    // window.gtag('event', 'conversion', {
    //   send_to: 'AW-707859189/UMH_CLLfvq8BEPWlxNEC',
    // });
  }
};

export default function* () {
  yield take(LOCATION_CHANGE, null);
  yield all([
    takeEvery(`BEFORE_${LOCATION_CHANGE}`, googleAnalyticsPageview),
    takeEvery(
      GA_COUPON_FAVORITE_ADDED,
      createGATrackingGenerator('Coupon', 'Coupon Favorite Added'),
    ),
    takeEvery(
      GA_COUPON_USED_BUYER,
      createGATrackingGenerator('Coupon', 'Buyer Used Coupon'),
    ),
    takeEvery(
      GA_COUPON_USED_SELLER,
      createGATrackingGenerator('Coupon', 'Seller Used Coupon'),
    ),
    takeEvery(
      GA_FIELD_DRAWN,
      createGATrackingGenerator('Field', 'Field Drawn'),
    ),
    takeEvery(
      GA_PAYMENT_ACCOUNT_ADDED,
      createGATrackingGenerator('Money', 'Payment Account Added'),
    ),
    takeEvery(
      GA_QUESTION_ASKED,
      createGATrackingGenerator('Question', 'Question Asked'),
    ),
    takeEvery(
      GA_QUOTE,
      createGATrackingGenerator('Transaction', 'Quote Request'),
    ),
    takeEvery(
      GA_OFFERING_POSTING_CATEGORY_REACHED,
      createGATrackingGenerator('Offering Posting', 'Posting Flow Started'),
    ),
    takeEvery(
      GA_OFFERING_POSTING_DATES_REACHED,
      createGATrackingGenerator('Offering Posting', 'Dates Page Reached'),
    ),
    takeEvery(
      GA_OFFERING_POSTING_EXTRA_FIELDS_REACHED,
      createGATrackingGenerator('Offering Posting', 'Extra Fields Reached'),
    ),
    takeEvery(
      GA_OFFERING_POSTING_IMAGES_REACHED,
      createGATrackingGenerator('Offering Posting', 'Images Reached'),
    ),
    takeEvery(
      GA_OFFERING_POSTING_LOCATION_REACHED,
      createGATrackingGenerator('Offering Posting', 'Location Reached'),
    ),
    takeEvery(
      GA_OFFERING_POSTING_PRICING_REACHED,
      createGATrackingGenerator('Offering Posting', 'Pricing Reached'),
    ),
    takeEvery(
      GA_OFFERING_POSTING_BANK_DETAILS_REACHED,
      createGATrackingGenerator('Offering Posting', 'Bank Info Reached'),
    ),
    takeEvery(
      GA_OFFERING_POSTING_TITLE_DESCRIPTION_REACHED,
      createGATrackingGenerator(
        'Offering Posting',
        'Title WantedDescription Reached',
      ),
    ),
    takeEvery(
      GA_OFFERING_POSTING_SUBMIT_REACHED,
      createGATrackingGenerator('Offering Posting', 'Submit Reached'),
    ),
    takeEvery(
      GA_OFFERING_CREATED,
      createGATrackingGenerator('Offering Posting', 'Offering Created'),
    ),
    takeEvery(GA_SIGNUP, createGATrackingGenerator('Account', 'Signup')),
    takeEvery(GA_SIGNUP, sendAdwordsTrackingEvent),
    takeEvery(GA_LOGIN, () => {
      createGATrackingGenerator('Account', 'Login');
    }),
    takeEvery(GA_LOGIN, () => {
      const storefrontSlugToNavigate = localStorage.getItem(
        'storefrontToNavigate',
      );
      if (storefrontSlugToNavigate) {
        setTimeout(() => {
          history.push(`/${storefrontSlugToNavigate}`);
          localStorage.removeItem('storefrontToNavigate');
        }, 200);
      }

      const storefrontSlugToFollow = localStorage.getItem('follow');
      if (storefrontSlugToFollow) {
        HitchpinApi.storefronts
          .getSingleBySlug(storefrontSlugToFollow)
          .then(res => {
            if (!res?.body.owner) {
              HitchpinApi.storefronts.follow(storefrontSlugToFollow);
              localStorage.removeItem('follow');
              history.push(`/${storefrontSlugToFollow}`);
            }
          });
      }

      const listingToBookmark = localStorage.getItem('bookmark');
      if (listingToBookmark) {
        HitchpinApi.bookmarks.addWishlistItemForOffering(listingToBookmark);
        localStorage.removeItem('bookmark');
      }
    }),
    takeEvery(GA_SIGNUP, () => {
      const storefrontSlugToFollow = localStorage.getItem('follow');
      if (storefrontSlugToFollow) {
        HitchpinApi.storefronts.follow(storefrontSlugToFollow);
        localStorage.removeItem('follow');
      }

      const listingToBookmark = localStorage.getItem('bookmark');
      if (listingToBookmark) {
        HitchpinApi.bookmarks.addWishlistItemForOffering(listingToBookmark);
        localStorage.removeItem('bookmark');
      }
    }),
  ]);
}
